<template>
    <div>
      <nav-breadcrumb :menu="[{label: '客户列表'},{label: '客户详情'}]"/>
      <el-row>
        <el-col>
          <el-tabs v-model="activeTabName" @tab-click="handleClick">
            <el-tab-pane label="客户总览" name="summary">

              <!--  第一个tabs -->
              <el-row :gutter="10">
                <el-col :span="24" class="bctabpanbgline"></el-col>
                <el-col :span="8" class="grid-content">

                  <el-card class="box-card box-card-hbg">
                    <div slot="header" class="clearfix">
                      <span>客户</span>
                    </div>
                    <div class="daikuan-mesg-list">
                        <div class="daikuan-money-all"><span>{{detailData.c__customerName}}</span>({{detailData.c__customerCode}})</div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="16" class="grid-content">

                  <el-card class="box-card box-card-hbg">
                    <div slot="header" class="clearfix">
                      <span>应还贷款总额</span>
                    </div>
                    <div class="daikuan-mesg-list2">
                      <el-row :gutter="10">
                        <el-col :span="9">
                          <div class="daikuan-money-all"><span>{{detailData.cr__outstandingAmount|formatMoney}}</span></div>
                        </el-col>
                        <el-col :span="9">
                          <div class="daikuan-money-benjin">本金总额 {{detailData.cr__outstandingPrincipalAmount|formatMoney}}</div>
                        </el-col>
                        <el-col :span="6">
                          <div class="daikuan-money-lixi">应还费用 {{detailData.cr__outstandingFeeAmount|formatMoney}}</div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="24" class="bctabpanbgline"></el-col>
                <el-col :span="16"><div class="grid-content bg-purple">
                  <el-card class="box-card box-card-hbg">
                    <div slot="header" class="clearfix">
                      <span>资产总览</span>
                    </div>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <div class="tc car-title" >信用评分</div>
                        <div class="of xz-tubiao-tongyong">
                          <ve-gauge :data="chartData" :settings="chartSettings"></ve-gauge>
                        </div>
                        <div class="tc of" >
                          <div>评估时间：{{new Date()|moment('YYYY-MM-DD')}} </div>
                          <!-- <el-button style="padding: 20px 0" type="text"></el-button> -->
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="tc car-title">车辆信息（共 <span>{{detailData.vehicles.length}}</span> 辆）</div>
                        <el-carousel indicator-position="outside" v-if="detailData.vehicles.length>0">
                          <el-carousel-item v-for="(item,idx ) in detailData.vehicles" :key="idx">
                            <div @click="viewCar(idx)">
                              <div class="car-mesg">{{item.vehicle__plateNo}}>{{item.vehicle__specification}}<br/></div>
                              <div class="car-foot">现估值：{{item.vehicle__currentValue|formatMoney}}元</div>
                            </div>
                          </el-carousel-item>
                        </el-carousel>
                        <el-carousel indicator-position="outside" v-else>
                          <el-carousel-item>
                              <div class="car-mesg">暂无数据<br/></div>
                              <div class="car-foot"></div>
                          </el-carousel-item>
                        </el-carousel>
                      </el-col>
                    </el-row>
                  </el-card>
                </div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple">
                  <el-card class="box-card box-card-hbg">
                    <div slot="header" class="clearfix">
                      <span>授信额度</span>
                      <el-button style="float: right; padding: 3px 0" type="text" @click="$router.push({path:'/pages/ServiceAdmin/Credit/List', query:{'c.customerId': detailData.c__customerId}})">授信记录</el-button>
                    </div>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <div class="text-top-mesg tc">可用额度：<span>{{creditDetailData.cr__creditBalance|formatMoney}}元/{{creditDetailData.cr__lineOfCredit|formatMoney}}元</span>&nbsp;&nbsp;<!--<el-button size="mini">提额</el-button>--></div>
                      </el-col>
                      <el-col :span="24" style="height:323px;">
                        <ve-pie :data="chartDataP" :settings="chartSettingsP" style="margin:0 auto;width:300px;"></ve-pie>
                      </el-col>
                    </el-row>
                  </el-card>
                </div></el-col>
                <el-dialog :visible.sync="dialogVisible" title="车辆信息">
                  <form-build
                    :form-data="car"
                    :form-columns="carColumns"
                    class="formTable"
                  />
                </el-dialog>
              </el-row>
              <!-- 第一个tabs结束 -->
            </el-tab-pane>
            <el-tab-pane label="客户资料" name="second" class="bg-purple">
              <customer-detail-component v-model="detailData" :is-show-pic1="true"/>
            </el-tab-pane>
            <el-tab-pane label="抵押车辆" name="vehicles" class="bg-purple">
              <customer-detail-vehicles-component v-model="detailData.vehicles" :is-show-pic1="true"/>
            </el-tab-pane>
            <el-tab-pane label="贷款信息" name="fourth" class="bg-purple">
              <customer-financing-list-component :customer-id="customerId"/>
            </el-tab-pane>
            <el-tab-pane label="账户信息" name="account" class="bg-purple">
              <customer-detail-account-component v-model="detailData"/>
              <el-row>
                <el-col :span="24">
                  <bank-account-data-table
                    :data="customerBankAccountData"
                    :customer-id="customerId"
                    @onUpdate="onUpdateBankAccount"
                    @onDelete="onDeleteBankAccount"
                  />
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="担保信息" name="guarantor" class="bg-purple">
              <customer-detail-guarantor-component v-model="detailData"/>
            </el-tab-pane>
            <el-tab-pane label="挂靠公司" name="ext-company" class="bg-purple">
              <customer-detail-ext-company-component v-model="detailData" />
            </el-tab-pane>
            <el-tab-pane label="授信审批" name="credit" class="bg-purple">
              <el-steps :active="6" class="step-shenpi">
                <el-step :title="'提交授信  '"  :description="$moment(creditData.ac__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>

                <el-step v-if="approvalListcount>1" class="step-spec" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName"  :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>2" class="step-spec" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName"  :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>3" class="step-spec" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName"  :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>4" class="step-spec" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName"  :description="$moment(approvalList[4].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step :title="'完成'" v-if="creditData.ac__applicationStatus == 'Approved'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
              </el-steps>
              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
              <template>
                <div>
                  <el-form label-width="150px">
                    <el-row>
                      <panel title="授信信息" border>
                        <el-col :span="24">
                          <el-form-item label="贷款产品：">
                            {{creditData.p__productName}}
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信类型：">
                            {{creditData.cr__creditType}}
                          </el-form-item>
                          <el-form-item label="授信起始日：">
                            {{creditData.cr__creditValidity1}}
                          </el-form-item>
                          <el-form-item label="贷款比例：">
                            {{creditData.cr__financingRatio}} %
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信额度：">
                            {{creditData.cr__lineOfCredit|formatMoney}} 元
                          </el-form-item>
                          <el-form-item label="授信到期日：">
                            {{creditData.cr__creditValidity2}}
                          </el-form-item>
                          <el-form-item label="贷款阈值：">
                            {{creditData.cr__threshold|formatMoney}} 元
                          </el-form-item>
                        </el-col>
                      </panel>
                    </el-row>
                  </el-form>
                </div>
              </template>
              <panel title="附件列表">
                <files-data-table :files.sync="creditData.files"></files-data-table>
              </panel>
              <el-steps :active="6" class="step-shenpi" v-if="creditData.m__applicationId!=null">
                <el-step :title="'提交申请'" :description = "$moment(creditData.m__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalMortgageListcount>0" :title="'抵押审核 '+approvalMortgageList[0].a__approverName" :description="$moment(approvalMortgageList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalMortgageList[0].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalMortgageListcount>1" :title="'风控审核 '+approvalMortgageList[1].a__approverName" :description="$moment(approvalMortgageList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalMortgageList[1].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
              </el-steps>
              <panel title="抵押审核" v-if="creditData.m__applicationId!=null">
                <data-table
                  :table-data="approvalMortgageArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
            </el-tab-pane>
            <el-tab-pane label="贷前风控" name="tongdun" class="bg-purple">
              <customer-tongdun-component v-model="detailData" :is-show-pic1="true"/>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <button-back></button-back>
    </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import CustomerDetailComponent from '../../components/CustomerDetailComponent'
  import ButtonBack from '../../../components/ButtonBack'
  import BankAccountDataTable from '../../components/BankAccountDataTable'
  import {removeItem} from "../../../filters/CommonActions";
  import DataTableComponent from "../../../components/DataTable";
  import CustomerDetailVehiclesComponent from "../../components/CustomerDetailVehiclesComponent";
  import CustomerFinancingListComponent from "../../components/CustomerFinancingListComponent";
  import CustomerTongdunComponent from "../../components/CustomerTongdunComponent";
  import Status2CN from '../../../filters/Status2CN'
  import moment from 'moment';
  import Panel from "../../../components/Panel";
  import {formatMoney} from "../../../filters/CommonFilters";
  import CustomerDetailAccountComponent from "../../components/CustomerDetailAccountComponent";
  import CustomerDetailGuarantorComponent from "../../components/CustomerDetailGuarantorComponent";
  import CustomerDetailExtCompanyComponent from "../../components/CustomerDetailExtCompanyComponent";

  export default {
    name: "CustomerDetail",
    data() {
      this.chartSettings = {
        labelMap: {
          'speed': '信用'
        },
        dataName: {
          'speed': '信用'
        },
        seriesMap: {
          'speed': {
            min: 0,
            max: 10,
            splitNumber: 5,
            radius: '75%',
            pointer:{
              show:true
            },
            startAngle:200,
            endAngle:-20
          },
        },
      },
      this.chartSettingsP = {
        level: [
          ['已用额度', '可用额度']
        ],
        label:{
          position:'inside'
        },
        radius:100
      }
      return {
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
        approvalArry:{
          data:[],
          count:0,
        },
        approvalMortgageArry:{
          data:[],
          count:0,
        },
        dialogVisible: false,
        activeTabName: 'summary',
        creditId: this.$route.query['cr.creditId'],
        customerId: this.$route.query['c.customerId'],
        applicationId:this.$route.query['ac.applicationId'],
        customerBankAccountData: {
          data:[],
          count:0
        },

        chartData: {
          columns: ['type', 'value'],
          rows: [
            { type: 'speed', value: 0 }
          ]
        },
        chartDataP: {
          columns: ['type', 'value'],
          rows: [
          ]
        },
        detailData: {
          score:'',
          decision:'',
          decisionDate:'',
          vehicles:[]
        },
        approvalListcount:0,
        approvalList:{},
        approvalMortgageList:{},
        approvalMortgageListcount:0,
        customerSummary:{},
        creditData:{},
        customerDetail:{},
        car:{},
        creditDetailData:{},
        invoiceList: {},
        contractList:{},
        financingList: {},

        invoiceColumns: [
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount',
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount'
          },
          {
            name: '币种',
            field: 'pi__currencyCode',
            formatter: function(r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
          },
          {
            label: '合同',
            opts: [
              {
                label: '下载',
                class: 'el-icon-download',
                clickHandler: function () {

                }
              }
            ]
          }
        ],
        carColumns : [
          {
            label: '车牌号',
            field: 'vehicle__plateNo',
          },
          {
            label: '车辆类型',
            field: 'vehicle__specification',
          },
          {
            label: '车架号',
            field: 'vehicle__vehicleNo',
          },
          {
            label: '发动机号',
            field: 'vehicle__engineNo',
          },
          {
            label: '期限/年月',
            field: 'vehicle__lifespan',
          },
          {
            label: '车辆单价',
            field: 'vehicle__buyPrice',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '折合后车辆单价',
            field: 'vehicle__currentValue',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: 'GPS号码',
            field: 'vehicle__GPS',
          },
          /*{
            label: ' 购买价格',
            field: 'vehicle__buyPrice',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },*/
          {
            label: '常用运营路线',
            field: 'vehicle__operatingLines',
          },
          {
            label: '违章次数',
            field: 'vehicle__trafficOffence',
          },
          {
            label: '里程（12个月）',
            field: 'vehicle__mileage12',
          },
          {
            label: '加油费（12个月）',
            field: 'vehicle__fuelExpense12',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          }, {
            label: '通行费（12个月）',
            field: 'vehicle__roadToll12',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },
        ],
        customerRepaymentList: {
          data: [],
          count: 0
        },
        customerRepaymentListColumns: [
          {
            label: '日期',
            field: 're__repayDate',
          },
          {
            label: '供应链',
            field: 'ct__debtorName',
          },
          {
            label: '融资编号',
            field: 'fi__transactionNo'
          },
          {
            label: '融资产品',
            field: 'ct__productName'
          },
          {
            label: '还款金额(元)',
            field: 're__repayAmount',
          },
          {
            label: '还款方式',
            field: '',
            formatter: function (r,c,v) {
              return '转账'
            }
          },
        ]
      }
    },
    filters:{
      Status2CN
    },
    components: {
      CustomerDetailExtCompanyComponent,
      CustomerDetailGuarantorComponent,
      CustomerDetailAccountComponent,
      Panel,
      CustomerFinancingListComponent,
      CustomerDetailVehiclesComponent,
      DataTableComponent,
      CustomerDetailComponent,
      ButtonBack,
      BankAccountDataTable,
      CustomerTongdunComponent,
    },
    mounted() {
      if( this.creditId ) {
        this.getCustomerCreditData(this.creditId)
      }
      this.getCustomerCreditDetail()
      this.getCustomerBankAccountList()
      this.getCustomerSummary()
      //this.getCustomerTongdun()
    },
    methods: {
      Status2CN,
      setMortgageApproval:function(){
        let count =1
        if(this.creditData.m__applicationId!=null){
          this.approvalMortgageArry.data.push(
            {
              node:'提交申请',
              approverName:'System',
              time:this.creditData.m__createdDate,
              status:'提交成功',
              remarks:'',

            }
          )
          for(var i=0;i<this.approvalMortgageList.length;i++){
            let name =this.approvalMortgageList[i].a__approvalType


            this.approvalMortgageArry.data.push(
              {
                node:name,
                approverName:this.approvalMortgageList[i].a__approverName,
                time:this.approvalMortgageList[i].a__approvingDate,
                status:Status2CN(this.approvalMortgageList[i].a__approvingStatus),
                remarks:this.approvalMortgageList[i].a__remarks,

              }
            )
            count++


          }
          this.approvalMortgageArry.count = count
        }
      },
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'提交授信',
            approverName:'System',
            time:this.customerDetail.c__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )
        console.log(this.approvalList)
        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__approvalType



          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalArry.count = count
        console.log(this.approvalArry)
      },

      getCustomerCreditData: function (creditId) {
        xhr.getCustomerCreditDetail({
            'cr.creditId': creditId,
            'm.applicationId':this.$route.query['m.applicationId']
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                res.data.data.cr__creditValidity = [
                  res.data.data.cr__creditValidity1,
                  res.data.data.cr__creditValidity2
                ]
                this.creditData = res.data.data
                this.getApplyingCustomerDetail()
                this.getMortgageApprovalList(this.$route.query['m.applicationId'])
              }
            }catch (e) {

            }
          })
      },
      getMortgageApprovalList: function(applicationId) {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalMortgageList = res.data.data
                this.approvalMortgageListcount = res.data.count
                console.log( res.data.count)

                this.setMortgageApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      getApplyingCustomerDetail: function () {
        xhr.getApplyingCustomerDetail({
          'c.applicationId': this.applicationId
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.customerDetail = res.data.data
              this.customerDetail.vehicles = this.customerDetail.vehicles.filter(item=>item.vehicle__vehicleId)
              /*if(this.customerDetail.c__applicationStatus=="Pending Approval"){
                this.getApplyCustomerCreditDetail(this.creditId);
              }*/
              this.getCustomerApprovalList()

            }
          }catch(e){}
        })
      },

      getCustomerApprovalList: function() {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': this.applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalList = res.data.data
                this.approvalListcount = res.data.count
                console.log(this.approvalListcount)
                this.setApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerSummary: function (customerId = this.customerId) {
        xhr.getCustomerSummary(
          {
          'c.customerId': customerId
           },
           res=> {
          try{
            if(res.data.status == 'success') {
              this.detailData = res.data.data

              this.detailData.decisionDate =''
              this.detailData.score =''
              this.detailData.decision =''


              this.detailData.vehicles = this.detailData.vehicles.filter(item=>item.vehicle__vehicleId)
              this.chartData.rows[0].value=5
              this.chartSettings.dataName.speed='信用良好'

            }
          }catch (e) {

          }
        }
        )
      },

      getCustomerCreditDetail: function (customerId = this.customerId) {
        xhr.getCustomerCreditList(
          {
            'xlist.search.cr.customerId': customerId,
            'xlist.search.cr.customerId.op': 'eq',
            pageSize: 1000
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                if(res.data.data.length>0){
                  this.creditDetailData = res.data.data.shift()
                  this.chartDataP.rows.push({'type':'可用额度','value':this.creditDetailData.cr__creditBalance})
                  this.chartDataP.rows.push({'type':'已用额度','value':(this.creditDetailData.cr__lineOfCredit-this.creditDetailData.cr__creditBalance)})
                }

              }
            }catch (e) {

            }
          }
        )
      },

      getCustomerDetail: function () {
        xhr.getCustomerDetail(
          {
            'c.customerId': this.$route.query['c.customerId']
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                this.detailData = res.data.data
                this.detailData.vehicles = this.detailData.vehicles.filter(item=>item.vehicle__vehicleId)
                this.chartData.rows[0].value=this.detailData.ix__extScore
                this.chartSettings.dataName.speed='信用'

              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerBankAccountList: function(customerId = this.customerId) {
        xhr.getCustomerBankAccountList(
          {
            'c.customerId': customerId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.customerBankAccountData = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      handleClick: function () {

      },
      onUpdateBankAccount: function (data) {
        xhr.updateCustomerBankAccount(
          data,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.getCustomerBankAccountList()
              }
            }catch (e) {

            }
          }
        )
      },
      onDeleteBankAccount: function (data) {
        removeItem(
          xhr.deleteCustomerBankAccount,

          {
            'ba.accountId': data.ba__accountId
          },

          ()=>{
            this.getCustomerBankAccountList()
          }
        )
      },
      getInvoiceList: function (customerId = this.customerId) {
        xhr.getCustomerInvoiceList(
          {
            'xlist.search.c.customerId': customerId,
            'xlist.search.c.customerId.op': 'eq',
            pageSize: 1000
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                let obj={}
                res.data.data.map(item=>{
                  if (typeof obj[item['ct__debtorName']] == 'undefined' ) {
                    obj[item['ct__debtorName']]= []
                  }
                  obj[item['ct__debtorName']].push(item)
                })
                this.invoiceList = obj
              }
            }catch (e) {

            }
          }
        )
      },
      getFinancingList: function (customerId = this.customerId) {
        xhr.getCustomerFinancingList(
          {
            'xlist.search.fi.customerId': customerId,
            'xlist.search.fi.customerId.op': 'eq',
            pageSize: 1000
          },
          res=> {
          try {
            if(res.data.status == 'success') {
              let obj = {}
              res.data.data.map(item=>{
                if (typeof obj[item['ct__debtorName']] == 'undefined' ) {
                  obj[item['ct__debtorName']]= []
                }
                obj[item['ct__debtorName']].push(item)
              })
              this.financingList = obj
            }
          }catch(e){

          }
        })

      },
      getCustomerRepaymentList: function (customerId = this.customerId) {
        xhr.getCustomerRepaymentList(
          {
            'xlist.search.fi.customerId': customerId,
            'xlist.search.fi.customerId.op': 'eq',
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.customerRepaymentList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerContractList : function (customerId = this.customerId) {
        xhr.getCustomerContractList(

          {
            'xlist.search.ct.customerId': customerId,
            'xlist.search.ct.customerId.op': 'eq',
            'xlist.search.ct.contractValidity2': moment().format('YYYY-MM-DD 23:59:59'),
            'xlist.search.ct.contractValidity2.op': 'gteq',
            'xlist.search.ct.contractValidity2.dateformat': 'yyyy-MM-dd 23:59:59'
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.contractList = res.data
              }
            }catch (e) {

            }
          }
        )
      },
      viewCar: function (idx) {
        this.car = this.detailData.vehicles[idx]
        this.dialogVisible = true
      },
      handleClick: function() {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerDetail.vue